module.exports = __webpack_public_path__ + "img/kitchen-desktop-inactive.ca6c34e.svg";